import { Loader2, Trash2 } from "lucide-react";
import { STATUS_COLOR } from "../../lib/applicationStatus";

export default function ApplicationsTable({ apps, loading, onView, onDelete }) {
  return (
    <div className="mt-6 border border-white/10 bg-[#0A1128]" data-testid="applications-table">
      <div className="grid grid-cols-12 border-b border-white/10 px-4 py-3 text-[10px] uppercase tracking-[0.28em] text-white/50">
        <div className="col-span-3">Applicant</div>
        <div className="col-span-3 hidden md:block">Reason</div>
        <div className="col-span-2 hidden sm:block">Submitted</div>
        <div className="col-span-2">Status</div>
        <div className="col-span-2 text-right">Actions</div>
      </div>

      {loading ? (
        <div className="flex items-center justify-center gap-3 p-10 text-white/60">
          <Loader2 className="h-4 w-4 animate-spin" /> Loading applications…
        </div>
      ) : apps.length === 0 ? (
        <div className="p-10 text-center text-white/50" data-testid="empty-state">
          No applications match your filters.
        </div>
      ) : (
        apps.map((a) => (
          <div
            key={a.id}
            className="grid grid-cols-12 items-center border-b border-white/5 px-4 py-4 text-sm transition-colors hover:bg-white/[0.03]"
            data-testid={`app-row-${a.id}`}
          >
            <div className="col-span-3 min-w-0">
              <div className="truncate font-serif text-lg text-white">
                {a.first_name} {a.last_name}
              </div>
              <div className="mt-0.5 truncate text-[10px] uppercase tracking-[0.2em] text-white/40">
                {a.id.slice(0, 8)}…
              </div>
            </div>
            <div className="col-span-3 hidden truncate text-white/70 md:block">{a.reason_for_loan}</div>
            <div className="col-span-2 hidden text-xs text-white/50 sm:block">
              {new Date(a.created_at).toLocaleString()}
            </div>
            <div className="col-span-2">
              <span
                className={`inline-block border px-2.5 py-1 text-[10px] uppercase tracking-[0.24em] ${
                  STATUS_COLOR[a.status] || ""
                }`}
              >
                {a.status}
              </span>
            </div>
            <div className="col-span-2 flex justify-end gap-2">
              <button
                onClick={() => onView(a)}
                data-testid={`view-app-${a.id}`}
                className="border border-white/15 px-3 py-1.5 text-[10px] uppercase tracking-[0.28em] text-white/80 hover:border-[#D4AF37] hover:text-[#D4AF37]"
              >
                View
              </button>
              <button
                onClick={() => onDelete(a)}
                data-testid={`delete-app-${a.id}`}
                aria-label="Delete application"
                className="inline-flex items-center justify-center border border-white/15 px-2.5 py-1.5 text-white/60 hover:border-red-400/60 hover:text-red-400"
              >
                <Trash2 className="h-3.5 w-3.5" strokeWidth={1.6} />
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
